export { LargeTitle } from './LargeTitle';
export { largeTitleClassNames } from './useLargeTitleStyles.styles';
